import React, { useEffect, useState } from 'react'

// components
import Header from '_components/header/index.jsx'
import ListView from '_components/list-view/index.jsx'
import UnifiedUserProfileWizard from '../wizard/index.jsx'

// services
import { cloneFeed, createFeed, deleteFeed } from '_services/event-feeds'

import { logErrorAsync } from '../../../lib/utility.js'
import BatchProcessModal from '_components/batch-process-modal/index.jsx'

import './styles.scss'

// constants
const ENTITY = 'unified-user-profile'

const getEnum = (fieldName) => {
  return new Promise((resolve, reject) => {
    window._api.get(`/${ENTITY}/enum/${fieldName}`, {}, (err, resp) => {
      if (err) {
        logErrorAsync(err)
        return reject(err)
      }
      resolve(resp)
    })
  })
}

const STATUSES = ['draft', 'submitted', 'processed', 'archived']

// Feeds Page
const UnifiedUserProfileListView = () => {
  const [wizardOpen, setWizardOpen] = useState(false)

  const [creators, setCreators] = useState([])
  const [deleting, setDeleting] = useState(false)
  const [deletePercentage, setDeletePercentage] = useState(0)
  const [selecteds, setSelecteds] = useState([])
  const [cloning, setCloning] = useState(false)
  const [clonePercentage, setClonePercentage] = useState(0)

  useEffect(() => {
    async function getEnums() {
      try {
        const creatorsResponse = await getEnum('created_by.email')
        setCreators(creatorsResponse)
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }
    }
    getEnums()
  }, [])

  const handleCreate = async (newUup) => {
    try {
      const response = await createFeed(ENTITY, newUup)
      setWizardOpen(false)
      window._history.push(`/unified-user-profile/${response._id}`)
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }
  }

  const handleDelete = async () => {
    setDeleting(true)
    const oneStepPercentage = 1 / selecteds.size
    for (const id of selecteds) {
      await deleteFeed(`${ENTITY}/${id}`, { id })
      setDeletePercentage((deletePercentage) => deletePercentage + oneStepPercentage)
    }
    setDeleting(false)
  }

  const handleClone = async () => {
    setCloning(true)
    const oneStepPercentage = 1 / selecteds.size
    for (const id of selecteds) {
      await cloneFeed(`${ENTITY}/clone/${id}`, { id })
      setClonePercentage((clonePercentage) => clonePercentage + oneStepPercentage)
    }
    setCloning(false)
  }

  return (
    <div id="unified-user-profile-page">
      <Header
        title="Unified User Profile"
        actions={[
          {
            children: 'Create Unified User Profile',
            onClick: () => setWizardOpen(true),
          },
        ]}
      />
      <ListView
        columns={[
          {
            name: 'Name',
            key: 'name',
            link: '/unified-user-profile/:_id',
            sortable: true,
            // width: 420,
          },
          // {
          //   key: 'client.name',
          //   link: '/companies/:client._id',
          //   name: 'Client',
          //   sortable: true,
          // },
          {
            format: 'date',
            name: 'Created At',
            key: 'created_at',
            sortable: true,
          },
          {
            format: 'date',
            key: 'updated_at',
            name: 'Last Updated',
            sortable: true,
          },
          {
            key: 'created_by',
            name: 'Created by',
            sortable: true,
            render: (item) => item.created_by.email,
          },
          {
            key: 'status',
            name: 'Status',
            sortable: true,
          },
        ]}
        entities={ENTITY}
        customPlaceholder="Search for name"
        filters={[
          // {
          //   label: 'Client',
          //   name: 'client.name',
          //   options: clients,
          //   all: true,
          //   className: 'unified-user-profile-list-view__filter',
          // },
          {
            label: 'Created by',
            name: 'created_by.email',
            options: creators,
            all: true,
            className: 'unified-user-profile-list-view__filter',
          },
          {
            label: 'Status',
            name: 'deliveries.status',
            options: STATUSES,
            all: true,
            className: 'unified-user-profile-list-view__filter',
          },
        ]}
        fields={['created_at', 'updated_at', 'name', 'created_by.email', 'status']}
        searchable={true}
        sort_key={'updated_at'}
        sort_dir={-1}
        actions={[
          {
            name: 'Clone',
            onClick: handleClone,
            icon: {
              icon: 'plus',
              type: 'outline',
            },
          },
          {
            name: 'Delete',
            onClick: handleDelete,
            icon: {
              icon: 'trashcan',
              type: 'outline',
            },
          },
        ]}
        onSelectionChange={({ currentSelected }) => setSelecteds(new Set(currentSelected))}
      />
      <UnifiedUserProfileWizard
        isOpen={wizardOpen}
        onClose={() => setWizardOpen(false)}
        onCreate={handleCreate}
      />
      <BatchProcessModal
        title="Deleting selected Unified User Profiles..."
        subtitle="This process will be done in a few seconds"
        isOpen={deleting}
        onClose={() => {}}
        onClick={() => {}}
        percentage={deletePercentage}
      />
      <BatchProcessModal
        title="Cloning selected Unified User Profiles..."
        subtitle="This process will be done in a few seconds"
        isOpen={cloning}
        onClose={() => {}}
        onClick={() => {}}
        percentage={clonePercentage}
      />
    </div>
  )
}

// export
export default UnifiedUserProfileListView
